import {
    Dialog,
    DialogTitle,
    List,
    ListItemButton,
    ListItemText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PaymentForm } from '../../types/payment';

type PaymentFormDialogProps = {
    pfs: PaymentForm[];
    onClose: () => void;
    open: boolean;
    onSelect: (paymentForm: PaymentForm) => void;
};

export default function PaymentFormDialog({
    pfs = [],
    onClose,
    open,
    onSelect,
}: PaymentFormDialogProps) {
    const { t } = useTranslation();

    const paymentForms = {
        CASH: t('payment.paymentFormCash'),
        PURSE: t('payment.paymentFormPurse'),
        BANK: t('payment.paymentFormBank'),
        DATAFONO: t('payment.paymentFormDataphone'),
        DATAFONO_CONNECTED: t('payment.paymentFormDataphoneConnected'),
        TPV: t('payment.paymentFormTpv'),
        RECEIPT: t('payment.paymentFormReceipt'),
        FREE: t('payment.paymentFormFree'),
        LATER: t('payment.paymentFormLater'),
        ZITYCARD: t('payment.paymentFormZitycard'),
        CASHDRO: t('payment.paymentFormCashdro'),
    };

    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>{t('payment.paymentForm')}</DialogTitle>
            <List>
                {pfs.map((paymentForm: any) => (
                    <ListItemButton
                        onClick={() => onSelect(paymentForm)}
                        key={paymentForm}
                    >
                        <ListItemText
                            primary={
                                paymentForms[
                                    paymentForm as keyof typeof paymentForms
                                ]
                            }
                        />
                    </ListItemButton>
                ))}
            </List>
        </Dialog>
    );
}
